import React, { useEffect } from "react";
import { IP } from "./../../internalServer";
import assets from "../../assets/assets";

const PdfViewer = ({ closeMideaviewer, attachment, handleRemovePdfVivwer }) => {
  const getFileUrl = (a) => {
    if (typeof a !== "string") return "";
    return a.startsWith(".") ? IP + a.slice(1) : a;
  };

  const attachmentUrl = getFileUrl(attachment);
  const fileUrl = `${IP}${attachmentUrl}`;

  console.log("fileUrl", fileUrl);

  const isPDF = (() => {
    if (typeof attachment !== "string") return false;
    try {
      const url = new URL(attachment);
      return url.pathname.toLowerCase().endsWith(".pdf");
    } catch {
      return attachment.toLowerCase().endsWith(".pdf");
    }
  })();

  // ⬇️ Auto-download ONLY non-PDF
  useEffect(() => {
    if (!fileUrl || isPDF) return;

    const link = document.createElement("a");
    link.href = encodeURI(fileUrl);
    link.download = attachment?.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    if (typeof handleRemovePdfVivwer === "function") {
      handleRemovePdfVivwer(false);
    } else if (typeof closeMideaviewer === "function") {
      closeMideaviewer(false);
    }
  }, [isPDF, fileUrl]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 999,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 60,
          right: 50,
          bottom: 20,
          left: 50,
          width: "80vw",
          margin: "auto",
          backgroundColor: "#fff",
        }}
      >
        {/* ✅ Show iframe ONLY for PDF */}
        {isPDF && (
          <iframe
            title="pdf-viewer"
            src={`https://docs.google.com/gview?url=${encodeURIComponent(
              fileUrl,
            )}&embedded=true`}
            className="iframe"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        )}

        <img
          src={assets.CrossIcon}
          alt="close"
          className="absolute top-[-20px] right-[-25px] cursor-pointer w-7 bg-white rounded-full"
          onClick={() => {
            if (typeof handleRemovePdfVivwer === "function") {
              handleRemovePdfVivwer(false);
            } else if (typeof closeMideaviewer === "function") {
              closeMideaviewer(false);
            }
          }}
        />
      </div>
    </div>
  );
};

export default PdfViewer;
